import axios from 'axios';
import store from '@/store';

const http = axios.create({ baseURL: 'https://api.zipixx.com' });
/*const http = axios.create({
	baseURL: process.env.VUE_APP_API_ENDPOINT
});*/

export { http };
